import React, { useState } from "react";
import "./Sidebar.scss";
import { Link } from "react-router-dom";
import { Menu, CustomLibMenu } from "../menu/Menu";
import Image from "../../../../components/ui/image/Image";
import { AppIcons } from "../../../../data/appIcons";
// import Image from "../../../components/image/Image";

const Sidebar = (props) => {
  const [selectedMenu, setSelectedMenu] = useState(null);

  const handleClick = (menu) => {
    if (selectedMenu === menu) {
      setSelectedMenu(null); // Remove class if same menu clicked again
    } else {
      setSelectedMenu(menu); // Add class to the clicked menu
    }
  };

  return (
    <>
      <div className="sidebar-section">
        <nav className="sidebar">
          <div className="main-menus">
            <button className="sidebar-toggler" type="button">
              <span className="sidebar-toggler-icon"></span>
            </button>{" "}
            <Link className="sidebar-brand">
              <Image
                imagePath={AppIcons.logoImage}
                imgCustomClassName="open-bar"
                altText="Icon"
              ></Image>
            </Link>
            <div className="sidebar-menu">
              <ul className="sidebar-menu-list">
                {Menu.map((menuItem, index) => {
                  return <li
                    key={index}
                    className={
                      selectedMenu === menuItem.id
                        ? "menu-item active-menu"
                        : "menu-item"
                    }
                    onClick={() => handleClick(menuItem.id)}
                  >
                    <Link to={menuItem.to} className={menuItem.subMenu ? "menu-arrow" : ""}>
                      <i className={menuItem.iconClass}></i>
                      <span>{menuItem.name}</span>
                    </Link>
                    {menuItem.subMenu ? (
                      <>
                        <ul className="sidebar-dropdown">
                          {menuItem.children.map((subMenu, index) => {
                            return <li className="dropdown-menus">
                              <Link to={subMenu.to} onClick={(e) => {
                                if (subMenu.onClick) {
                                  subMenu.onClick(e);
                                }
                              }}>{subMenu.submenuName}</Link>
                            </li>
                          })}
                        </ul>
                      </>
                    ) : null}
                  </li>
                })}
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
